import { CanActivateFn, UrlTree, createUrlTreeFromSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { selectIsAuthenticated } from '../authentication.reducer';
import { Observable } from 'rxjs';
import { IRootState } from '../../../app/app.config';

export const loggedInGuard: CanActivateFn = (route, state) => {
  const store$ = inject(Store<IRootState>);

  return new Observable<boolean | UrlTree>((observer) => {
    store$.select(selectIsAuthenticated).subscribe((state) => {
      if (state) {
        if (route.routeConfig?.path === 'login' || route.routeConfig?.path === 'register') {
          observer.next(createUrlTreeFromSnapshot(route, [''])); // User is logged in, redirect to dashboard page
          observer.complete();
        } else {
          observer.next(true); // User is not logged in, allow navigation
          observer.complete();
        }
      } else {
        observer.next(true); // User is not logged in, allow navigation
        observer.complete();
      }
    })
  });
};
